// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeKindofTrip-space1-Dd77_ {
	margin-bottom: 6px !important;
}

.HomeKindofTrip-space2-pk8mt {
	margin-bottom: 12px !important;
}

.HomeKindofTrip-space3-bW3R6 {
	margin-bottom: 18px !important;
}

.HomeKindofTrip-space4-sbX0h {
	margin-bottom: 24px !important;
}

.HomeKindofTrip-space5-T3IMW {
	margin-bottom: 30px !important;
}

.HomeKindofTrip-space6-GqtQx {
	margin-bottom: 36px !important;
}

.HomeKindofTrip-space7-WCrfp {
	margin-bottom: 42px !important;
}

.HomeKindofTrip-spaceTop8-KjVAn {
	margin-bottom: 48px !important;
}

.HomeKindofTrip-spaceTop1-Ujwig {
	margin-top: 6px !important;
}

.HomeKindofTrip-spaceTop2-N2WGA {
	margin-top: 12px !important;
}

.HomeKindofTrip-spaceTop3-tsKQV {
	margin-top: 18px !important;
}

.HomeKindofTrip-spaceTop4-H2FAo {
	margin-top: 24px !important;
}

.HomeKindofTrip-spaceTop5-KssFg {
	margin-top: 30px !important;
}

.HomeKindofTrip-spaceTop6-GedI1 {
	margin-top: 36px !important;
}

.HomeKindofTrip-spaceTop7-wc64P {
	margin-top: 42px !important;
}

.HomeKindofTrip-spaceTop8-KjVAn {
	margin-top: 48px !important;
}

.HomeKindofTrip-noMargin-hzXiC {
	margin: 0px !important;
}

.HomeKindofTrip-padding1-VZpjN {
	padding-bottom: 6px !important;
}

.HomeKindofTrip-padding2-pvMbe {
	padding-bottom: 12px !important;
}

.HomeKindofTrip-padding3-NUCnV {
	padding-bottom: 18px !important;
}

.HomeKindofTrip-padding4-yRC3x {
	padding-bottom: 24px !important;
}

.HomeKindofTrip-padding5-vT7wx {
	padding-bottom: 30px !important;
}

.HomeKindofTrip-padding6-UrSnf {
	padding-bottom: 36px !important;
}

.HomeKindofTrip-padding7-_WcL0 {
	padding-bottom: 42px !important;
}

.HomeKindofTrip-paddingTop1-NnEk0 {
	padding-top: 6px !important;
}

.HomeKindofTrip-paddingTop2-Vmlw7 {
	padding-top: 12px !important;
}

.HomeKindofTrip-paddingTop3-TrwzB {
	padding-top: 18px !important;
}

.HomeKindofTrip-paddingTop4-hkbEs {
	padding-top: 24px !important;
}

.HomeKindofTrip-paddingTop5-rMv29 {
	padding-top: 30px !important;
}

.HomeKindofTrip-paddingTop6-KuYIx {
	padding-top: 36px !important;
}

.HomeKindofTrip-paddingTop7-cRnF1 {
	padding-top: 42px !important;
}

.HomeKindofTrip-noPadding-BqCMp {
	padding: 0px !important;
}

.HomeKindofTrip-textBold-CE16e {
	font-weight: 500 !important;
}

.HomeKindofTrip-textBolder-_YNEd {
	font-weight: 700 !important;
}

.HomeKindofTrip-textNormal-kbbZp {
	font-weight: normal !important;
}

.HomeKindofTrip-spaceBottom20-zVp7q {
	margin-bottom: 20px;
}

.HomeKindofTrip-spaceBottom10-EwRl5 {
	margin-bottom: 10px;
}

.HomeKindofTrip-marginNone-BkSCR {
	margin: 0;
}

.HomeKindofTrip-spaceBottom15-QgI5J {
	margin-bottom: 15px;
}

.HomeKindofTrip-marginTopNone-_HDtE {
	margin-top: 0;
}

.HomeKindofTrip-spaceTop11-eRk88 {
	margin-top: 11px;
}

.HomeKindofTrip-spaceTop21-Vx4nr {
	margin-top: 21px;
}

.HomeKindofTrip-spaceTop20-RknL1 {
	margin-top: 20px;
}

.HomeKindofTrip-spaceTop10-wR5yJ {
	margin-top: 10px;
}

/*New Design Text Colors */

.HomeKindofTrip-textDarkBlue-KIEs0 {
	color: rgb(20, 39, 94) !important;
}

.HomeKindofTrip-textLightBlue-lBM2r {
	color: rgb(57, 87, 106) !important;
}

.HomeKindofTrip-textLightSandleGreen-J6e_3 {
	color: rgb(76, 86, 41) !important;
}

.HomeKindofTrip-textLightBrown-lZ8QP {
	color: rgb(115, 79, 33) !important;
}

.HomeKindofTrip-textMediumMaroon-oy3L3 {
	color: rgb(87, 37, 51) !important;
}

.HomeKindofTrip-textBrown-qcTau {
	color: rgb(160, 47, 24) !important;
}

.HomeKindofTrip-textMaroon-JLfXj {
	color: rgb(155, 49, 67) !important;
}

.HomeKindofTrip-textDarkBrown-vrxso {
	color: rgb(83, 18, 16) !important;
}

.HomeKindofTrip-textMediumBrown-qCaAF {
	color: rgb(142, 28, 10) !important;
}

.HomeKindofTrip-textSkyBlue-KbPGc {
	color: rgb(37, 117, 141) !important;
}

.HomeKindofTrip-textGray-Q4D5a {
	color: rgb(77, 65, 51) !important;
}

.HomeKindofTrip-container-N3Aui {
	width: 100%;
	max-width: 1274px;
	margin: 0 auto;
}

.HomeKindofTrip-homeFindHeader-a0UTh {
	font-weight: 600;
	font-size: 32px;
}

.HomeKindofTrip-homePara-TliRh {
	font-size: 16px;
	margin-top: 10px;
}

.HomeKindofTrip-homeParaInner-oXJTX {
	font-size: 16px;
	color: var(--common-primary-white-foreground);
	padding-top: 12px;
}

.HomeKindofTrip-homeFindSmall-ZJCnT {
	font-size: 20px;
	font-weight: bold;
	color: var(--primary-bg);
	margin: 10px 0 2px 0;
}

.HomeKindofTrip-homeFindSmallColor-K3vs3 {
	font-size: 20px;
	font-weight: bold;
	color: var(--primary-bg);
	margin: 10px 0 2px 0;
}

.HomeKindofTrip-homeFindMain-f1iEB {
	margin: 48px 0 0 0;
}

.HomeKindofTrip-homeFind-nUU_5 {
	padding: 70px 0px 70px;
}

.HomeKindofTrip-homeFindBg-n9I08 {
	width: 100%;
	height: 465px;
	background-position: 50% 50%;
	background-size: cover;
	background-repeat: no-repeat;
	position: relative;
	border-radius: 20px;
	overflow: hidden;
}

.HomeKindofTrip-homeFindBg-n9I08::before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: transparent -webkit-gradient(linear, left bottom, left top, from(#1A0000), to(#55555500)) 0% 0% no-repeat padding-box;
	background: transparent linear-gradient(0deg, #1A0000 0%, #55555500 100%) 0% 0% no-repeat padding-box;
	border-radius: 20px;
}

.HomeKindofTrip-SectionPadding-GtDBL {
	padding: 0 2px;
}

.HomeKindofTrip-position-IUiVC {
	position: absolute;
	bottom: 20px;
	padding: 0 15px 0 20px;
}

@media screen and (max-width: 1170px) {
	.HomeKindofTrip-containerTitle-lYIaW {
		text-align: center;
	}
}

@media (max-width: 1199px) and (min-width: 768px) {
	.HomeKindofTrip-SectionPadding-GtDBL {
		padding: 0px 0px;
	}

	.HomeKindofTrip-containerPadding-s6ruU {
		padding: 0 23px;
	}
}

@media screen and (max-width: 640px) {
	.HomeKindofTrip-homeFindBg-n9I08 {
		width: 100%;
		height: 100%;
		min-height: 185px;
		max-height: 185px;
	}

	.HomeKindofTrip-paddingTopMobile-kX4mY {
		padding: 20px 0 0 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Home/HomeKindofTrip/HomeKindofTrip.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,6CAA6C;CAC7C,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,4BAA4B;CAC5B,sBAAsB;CACtB,4BAA4B;CAC5B,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,iIAAqG;CAArG,qGAAqG;CACrG,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,mBAAmB;CACpB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n.container {\n\twidth: 100%;\n\tmax-width: 1274px;\n\tmargin: 0 auto;\n}\n\n.homeFindHeader {\n\tfont-weight: 600;\n\tfont-size: 32px;\n}\n\n.homePara {\n\tfont-size: 16px;\n\tmargin-top: 10px;\n}\n\n.homeParaInner {\n\tfont-size: 16px;\n\tcolor: var(--common-primary-white-foreground);\n\tpadding-top: 12px;\n}\n\n.homeFindSmall {\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tcolor: var(--primary-bg);\n\tmargin: 10px 0 2px 0;\n}\n\n.homeFindSmallColor {\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tcolor: var(--primary-bg);\n\tmargin: 10px 0 2px 0;\n}\n\n.homeFindMain {\n\tmargin: 48px 0 0 0;\n}\n\n.homeFind {\n\tpadding: 70px 0px 70px;\n}\n\n.homeFindBg {\n\twidth: 100%;\n\theight: 465px;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tposition: relative;\n\tborder-radius: 20px;\n\toverflow: hidden;\n}\n\n.homeFindBg::before {\n\tcontent: \"\";\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: transparent linear-gradient(0deg, #1A0000 0%, #55555500 100%) 0% 0% no-repeat padding-box;\n\tborder-radius: 20px;\n}\n\n.SectionPadding {\n\tpadding: 0 2px;\n}\n\n.position {\n\tposition: absolute;\n\tbottom: 20px;\n\tpadding: 0 15px 0 20px;\n}\n\n@media screen and (max-width: 1170px) {\n\t.containerTitle {\n\t\ttext-align: center;\n\t}\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n\t.SectionPadding {\n\t\tpadding: 0px 0px;\n\t}\n\n\t.containerPadding {\n\t\tpadding: 0 23px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.homeFindBg {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmin-height: 185px;\n\t\tmax-height: 185px;\n\t}\n\n\t.paddingTopMobile {\n\t\tpadding: 20px 0 0 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `HomeKindofTrip-space1-Dd77_`,
	"space2": `HomeKindofTrip-space2-pk8mt`,
	"space3": `HomeKindofTrip-space3-bW3R6`,
	"space4": `HomeKindofTrip-space4-sbX0h`,
	"space5": `HomeKindofTrip-space5-T3IMW`,
	"space6": `HomeKindofTrip-space6-GqtQx`,
	"space7": `HomeKindofTrip-space7-WCrfp`,
	"spaceTop8": `HomeKindofTrip-spaceTop8-KjVAn`,
	"spaceTop1": `HomeKindofTrip-spaceTop1-Ujwig`,
	"spaceTop2": `HomeKindofTrip-spaceTop2-N2WGA`,
	"spaceTop3": `HomeKindofTrip-spaceTop3-tsKQV`,
	"spaceTop4": `HomeKindofTrip-spaceTop4-H2FAo`,
	"spaceTop5": `HomeKindofTrip-spaceTop5-KssFg`,
	"spaceTop6": `HomeKindofTrip-spaceTop6-GedI1`,
	"spaceTop7": `HomeKindofTrip-spaceTop7-wc64P`,
	"noMargin": `HomeKindofTrip-noMargin-hzXiC`,
	"padding1": `HomeKindofTrip-padding1-VZpjN`,
	"padding2": `HomeKindofTrip-padding2-pvMbe`,
	"padding3": `HomeKindofTrip-padding3-NUCnV`,
	"padding4": `HomeKindofTrip-padding4-yRC3x`,
	"padding5": `HomeKindofTrip-padding5-vT7wx`,
	"padding6": `HomeKindofTrip-padding6-UrSnf`,
	"padding7": `HomeKindofTrip-padding7-_WcL0`,
	"paddingTop1": `HomeKindofTrip-paddingTop1-NnEk0`,
	"paddingTop2": `HomeKindofTrip-paddingTop2-Vmlw7`,
	"paddingTop3": `HomeKindofTrip-paddingTop3-TrwzB`,
	"paddingTop4": `HomeKindofTrip-paddingTop4-hkbEs`,
	"paddingTop5": `HomeKindofTrip-paddingTop5-rMv29`,
	"paddingTop6": `HomeKindofTrip-paddingTop6-KuYIx`,
	"paddingTop7": `HomeKindofTrip-paddingTop7-cRnF1`,
	"noPadding": `HomeKindofTrip-noPadding-BqCMp`,
	"textBold": `HomeKindofTrip-textBold-CE16e`,
	"textBolder": `HomeKindofTrip-textBolder-_YNEd`,
	"textNormal": `HomeKindofTrip-textNormal-kbbZp`,
	"spaceBottom20": `HomeKindofTrip-spaceBottom20-zVp7q`,
	"spaceBottom10": `HomeKindofTrip-spaceBottom10-EwRl5`,
	"marginNone": `HomeKindofTrip-marginNone-BkSCR`,
	"spaceBottom15": `HomeKindofTrip-spaceBottom15-QgI5J`,
	"marginTopNone": `HomeKindofTrip-marginTopNone-_HDtE`,
	"spaceTop11": `HomeKindofTrip-spaceTop11-eRk88`,
	"spaceTop21": `HomeKindofTrip-spaceTop21-Vx4nr`,
	"spaceTop20": `HomeKindofTrip-spaceTop20-RknL1`,
	"spaceTop10": `HomeKindofTrip-spaceTop10-wR5yJ`,
	"textDarkBlue": `HomeKindofTrip-textDarkBlue-KIEs0`,
	"textLightBlue": `HomeKindofTrip-textLightBlue-lBM2r`,
	"textLightSandleGreen": `HomeKindofTrip-textLightSandleGreen-J6e_3`,
	"textLightBrown": `HomeKindofTrip-textLightBrown-lZ8QP`,
	"textMediumMaroon": `HomeKindofTrip-textMediumMaroon-oy3L3`,
	"textBrown": `HomeKindofTrip-textBrown-qcTau`,
	"textMaroon": `HomeKindofTrip-textMaroon-JLfXj`,
	"textDarkBrown": `HomeKindofTrip-textDarkBrown-vrxso`,
	"textMediumBrown": `HomeKindofTrip-textMediumBrown-qCaAF`,
	"textSkyBlue": `HomeKindofTrip-textSkyBlue-KbPGc`,
	"textGray": `HomeKindofTrip-textGray-Q4D5a`,
	"container": `HomeKindofTrip-container-N3Aui`,
	"homeFindHeader": `HomeKindofTrip-homeFindHeader-a0UTh`,
	"homePara": `HomeKindofTrip-homePara-TliRh`,
	"homeParaInner": `HomeKindofTrip-homeParaInner-oXJTX`,
	"homeFindSmall": `HomeKindofTrip-homeFindSmall-ZJCnT`,
	"homeFindSmallColor": `HomeKindofTrip-homeFindSmallColor-K3vs3`,
	"homeFindMain": `HomeKindofTrip-homeFindMain-f1iEB`,
	"homeFind": `HomeKindofTrip-homeFind-nUU_5`,
	"homeFindBg": `HomeKindofTrip-homeFindBg-n9I08`,
	"SectionPadding": `HomeKindofTrip-SectionPadding-GtDBL`,
	"position": `HomeKindofTrip-position-IUiVC`,
	"containerTitle": `HomeKindofTrip-containerTitle-lYIaW`,
	"containerPadding": `HomeKindofTrip-containerPadding-s6ruU`,
	"paddingTopMobile": `HomeKindofTrip-paddingTopMobile-kX4mY`
};
module.exports = ___CSS_LOADER_EXPORT___;
